import React from "react";
import { Header } from "../../../components/Header";
import { SolutionDetailBanner } from "../../../blocks/solution-detail-banner";
// import { CommonBanner } from "../../blocks/common-banner";
import { SolutionDetailContent } from "../../../blocks/solution-detail-content";
// import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { SolutionConsult } from "../../../blocks/common-solution-consult";
import { Footer } from "../../../components/Footer";
// import { CommonLinkPage } from "../../../blocks/common-link-page";

export const SolutionDetail = () => {
  const { type } = useParams();
  const { t } = useTranslation();
  // const pagesLink = [
  //   {
  //     title: t("common.pageLink.keycloak.title"),
  //     description: t("common.pageLink.keycloak.description"),
  //     imgurl: "/page-link-solution-keycloak.png",
  //     jumpLink: "/solutions/keycloak",
  //   },
  //   {
  //     title: t("common.pageLink.buildIdaas.title"),
  //     description: t("common.pageLink.buildIdaas.description"),
  //     imgurl: "/page-link-solution-build-idaas.png",
  //     jumpLink: "/solutions/build-idaas",
  //   },
  //   {
  //     title: t("common.pageLink.wechat.title"),
  //     description: t("common.pageLink.wechat.description"),
  //     imgurl: "/page-link-solution-wechat.png",
  //     jumpLink: "/solutions/wechat",
  //   },
  // ];
  const data = {
    medical: {
      title: `${t("solution.detail.medical.title")}`,
      sub: `${t("solution.detail.medical.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.medical.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.medical.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-weisheng icon-style",
        },
        {
          title: `${t("solution.detail.medical.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.medical.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-duochongshenfen icon-style",
        },
        {
          title: `${t("solution.detail.medical.challenges.item-three.title")}`,
          content: `${t(
            "solution.detail.medical.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-butongxitong icon-style",
        },
        {
          title: `${t("solution.detail.medical.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.medical.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.medical.values.item-one.title")}`,
          content: `${t("solution.detail.medical.values.item-one.content")}`,
          icon: "icon authing-icon authing-shujuyinsi icon-default",
        },
        {
          title: `${t("solution.detail.medical.values.item-two.title")}`,
          content: `${t("solution.detail.medical.values.item-two.content")}`,
          icon: "icon authing-icon authing-yiyuan icon-default",
        },
        {
          title: `${t("solution.detail.medical.values.item-three.title")}`,
          content: `${t("solution.detail.medical.values.item-three.content")}`,
          icon: "icon authing-icon authing-tongyixitong icon-default",
        },
        {
          title: `${t("solution.detail.medical.values.item-four.title")}`,
          content: `${t("solution.detail.medical.values.item-four.content")}`,
          icon: "icon authing-icon authing-zhihuichengshi icon-default",
        },
      ],
    },
    game: {
      title: `${t("solution.detail.game.title")}`,
      sub: `${t("solution.detail.game.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.game.challenges.item-one.title")}`,
          content: `${t("solution.detail.game.challenges.item-one.content")}`,
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        {
          title: `${t("solution.detail.game.challenges.item-two.title")}`,
          content: `${t("solution.detail.game.challenges.item-two.content")}`,
          icon: "icon authing-icon authing-management icon-style",
        },
        {
          title: `${t("solution.detail.game.challenges.item-three.title")}`,
          content: `${t("solution.detail.game.challenges.item-three.content")}`,
          icon: "icon authing-icon authing-Consume icon-style",
        },
        {
          title: `${t("solution.detail.game.challenges.item-four.title")}`,
          content: `${t("solution.detail.game.challenges.item-four.content")}`,
          icon: "icon authing-icon authing-zhouqi icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.game.values.item-one.title")}`,
          content: `${t("solution.detail.game.values.item-one.content")}`,
          icon: "icon authing-icon authing-Safety icon-default",
        },
        {
          title: `${t("solution.detail.game.values.item-two.title")}`,
          content: `${t("solution.detail.game.values.item-two.content")}`,
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        {
          title: `${t("solution.detail.game.values.item-three.title")}`,
          content: `${t("solution.detail.game.values.item-three.content")}`,
          icon: "icon authing-icon authing-management icon-default",
        },
        {
          title: `${t("solution.detail.game.values.item-four.title")}`,
          content: `${t("solution.detail.game.values.item-four.content")}`,
          icon: "icon authing-icon authing-Smooth icon-default",
        },
      ],
    },
    software: {
      title: `${t("solution.detail.software.title")}`,
      sub: `${t("solution.detail.software.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.software.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-highcost icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-Safety icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-three.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-jihui icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-low-cost icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.software.values.item-one.title")}`,
          content: `${t("solution.detail.software.values.item-one.content")}`,
          icon: "icon authing-icon authing-low-cost icon-default",
        },
        {
          title: `${t("solution.detail.software.values.item-two.title")}`,
          content: `${t("solution.detail.software.values.item-two.content")}`,
          icon: "icon authing-icon authing-Safety icon-default",
        },
        {
          title: `${t("solution.detail.software.values.item-three.title")}`,
          content: `${t("solution.detail.software.values.item-three.content")}`,
          icon: "icon authing-icon authing-value icon-default",
        },
        {
          title: `${t("solution.detail.software.values.item-four.title")}`,
          content: `${t("solution.detail.software.values.item-four.content")}`,
          icon: "icon authing-icon authing-chuangxin icon-default",
        },
      ],
    },
    government: {
      title: `${t("solution.detail.government.title")}`,
      sub: `${t("solution.detail.government.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.government.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.government.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-shujufensan icon-style",
        },
        {
          title: `${t("solution.detail.government.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.government.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-highcost icon-style",
        },
        {
          title: `${t(
            "solution.detail.government.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.government.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-deploy icon-style",
        },
        {
          title: `${t(
            "solution.detail.government.challenges.item-four.title"
          )}`,
          content: `${t(
            "solution.detail.government.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-userexperience icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.government.values.item-one.title")}`,
          content: `${t("solution.detail.government.values.item-one.content")}`,
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        {
          title: `${t("solution.detail.government.values.item-two.title")}`,
          content: `${t("solution.detail.government.values.item-two.content")}`,
          icon: "icon authing-icon authing-Safety icon-default",
        },
        {
          title: `${t("solution.detail.government.values.item-three.title")}`,
          content: `${t(
            "solution.detail.government.values.item-three.content"
          )}`,
          icon: "icon authing-icon authing-monitor icon-default",
        },
        {
          title: `${t("solution.detail.government.values.item-four.title")}`,
          content: `${t(
            "solution.detail.government.values.item-four.content"
          )}`,
          icon: "icon authing-icon authing-acquisitionModality icon-default",
        },
      ],
    },
    finance: {
      title: `${t("solution.detail.finance.title")}`,
      sub: `${t("solution.detail.finance.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.finance.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-tiyan icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-hinder icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-three.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-kaifa icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-xitong-2 icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.finance.values.item-one.title")}`,
          content: `${t("solution.detail.finance.values.item-one.content")}`,
          icon: "icon authing-icon authing-tiyan icon-default",
        },
        {
          title: `${t("solution.detail.finance.values.item-two.title")}`,
          content: `${t("solution.detail.finance.values.item-two.content")}`,
          icon: "icon authing-icon authing-zhuanxingjia icon-default",
        },
        {
          title: `${t("solution.detail.finance.values.item-three.title")}`,
          content: `${t("solution.detail.finance.values.item-three.content")}`,
          icon: "icon authing-icon authing-duozhong icon-default",
        },
        {
          title: `${t("solution.detail.finance.values.item-four.title")}`,
          content: `${t("solution.detail.finance.values.item-four.content")}`,
          icon: "icon authing-icon authing-Safety icon-default",
        },
      ],
    },
    publisher: {
      title: `${t("solution.detail.publisher.title")}`,
      sub: `${t("solution.detail.publisher.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.publisher.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-opportunity-growth icon-style",
        },
        {
          title: `${t("solution.detail.publisher.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-highcost icon-style",
        },
        {
          title: `${t(
            "solution.detail.publisher.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-tushuguanli icon-style",
        },
        {
          title: `${t("solution.detail.publisher.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-Safety icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.publisher.values.item-one.title")}`,
          content: `${t("solution.detail.publisher.values.item-one.content")}`,
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        {
          title: `${t("solution.detail.publisher.values.item-two.title")}`,
          content: `${t("solution.detail.publisher.values.item-two.content")}`,
          icon: "icon authing-icon authing-Safety icon-default",
        },
        {
          title: `${t("solution.detail.publisher.values.item-three.title")}`,
          content: `${t(
            "solution.detail.publisher.values.item-three.content"
          )}`,
          icon: "icon authing-icon authing-user icon-default",
        },
        {
          title: `${t("solution.detail.publisher.values.item-four.title")}`,
          content: `${t("solution.detail.publisher.values.item-four.content")}`,
          icon: "icon authing-icon authing-multiple-roles icon-default",
        },
      ],
    },
    education: {
      title: `${t("solution.detail.education.title")}`,
      sub: `${t("solution.detail.education.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.education.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        {
          title: `${t("solution.detail.education.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-Consume icon-style",
        },
        {
          title: `${t(
            "solution.detail.education.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.education.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-management icon-style",
        },
        {
          title: `${t("solution.detail.education.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.education.values.item-one.title")}`,
          content: `${t("solution.detail.education.values.item-one.content")}`,
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        {
          title: `${t("solution.detail.education.values.item-two.title")}`,
          content: `${t("solution.detail.education.values.item-two.content")}`,
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        {
          title: `${t("solution.detail.education.values.item-three.title")}`,
          content: `${t(
            "solution.detail.education.values.item-three.content"
          )}`,
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        {
          title: `${t("solution.detail.education.values.item-four.title")}`,
          content: `${t("solution.detail.education.values.item-four.content")}`,
          icon: "icon authing-icon authing-sheding icon-default",
        },
      ],
    },
    enterprise: {
      title: `${t("solution.detail.enterprise.title")}`,
      sub: `${t("solution.detail.enterprise.sub")}`,
      challenges: [
        {
          title: `${t("solution.detail.enterprise.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.enterprise.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        {
          title: `${t("solution.detail.enterprise.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.enterprise.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-Consume icon-style",
        },
        {
          title: `${t(
            "solution.detail.enterprise.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.enterprise.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-management icon-style",
        },
        {
          title: `${t(
            "solution.detail.enterprise.challenges.item-four.title"
          )}`,
          content: `${t(
            "solution.detail.enterprise.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      ],
      values: [
        {
          title: `${t("solution.detail.enterprise.values.item-one.title")}`,
          content: `${t("solution.detail.enterprise.values.item-one.content")}`,
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        {
          title: `${t("solution.detail.enterprise.values.item-two.title")}`,
          content: `${t("solution.detail.enterprise.values.item-two.content")}`,
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        {
          title: `${t("solution.detail.enterprise.values.item-three.title")}`,
          content: `${t(
            "solution.detail.enterprise.values.item-three.content"
          )}`,
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        {
          title: `${t("solution.detail.enterprise.values.item-four.title")}`,
          content: `${t(
            "solution.detail.enterprise.values.item-four.content"
          )}`,
          icon: "icon authing-icon authing-sheding icon-default",
        },
      ],
    },
  };
  return (
    <div className="solution-detail-page">
      <Header key={type} mode={"light"} />
      <SolutionDetailBanner {...data[type]} />
      <SolutionDetailContent {...data[type]} />
      {/* <CommonLinkPage pagesLink={pagesLink} /> */}
      <SolutionConsult />
      <Footer />
    </div>
  );
};
